import PropTypes from 'prop-types';
import React from 'react';
import Time from 'react-time';
import moment from 'moment';
import { WidgetsStatusBadge } from '../../projects/ProjectDashboard/WidgetsStatusBadge.jsx';

const getStatus = (startDate, endDate) => {
  const now = moment();
  if (now.isAfter(endDate, 'day')) return 'Completed';
  if (now.isBefore(startDate, 'day')) return 'Upcoming';
  return 'Active';
};

const InitiativeDateColumn = ({ initiative: { startDate, endDate } }) => {
  const showDateRange = !startDate.isSame(endDate);
  const status = getStatus(startDate, endDate);

  return (
    <td className="initiative-date-column">
      <div className="strong">
        <Time value={startDate} format="M/D/YY" />
        {showDateRange && (
          <span>
            {' '}
            –
            <Time value={endDate} format="M/D/YY" />
          </span>
        )}
      </div>
      <WidgetsStatusBadge sentiment={status.toLowerCase()} />
    </td>
  );
};

InitiativeDateColumn.propTypes = {
  initiative: PropTypes.shape({
    startDate: PropTypes.object.isRequired,
    endDate: PropTypes.object.isRequired,
  }).isRequired,
};

export default InitiativeDateColumn;
